import { render, staticRenderFns } from "./Shorts.vue?vue&type=template&id=3399e1a6&"
import script from "./Shorts.vue?vue&type=script&lang=ts&"
export * from "./Shorts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports